// eslint-disable-next-line max-classes-per-file
import { AxiosResponse } from 'axios';

import { instance as axios } from 'api/axios';

class MyError extends Error {
  errorExtraParamsGet;

  constructor(message: any, errorExtraParams: any) {
    super(message);
    this.errorExtraParamsGet = errorExtraParams;
  }

  get errorExtraParams() {
    return this.errorExtraParamsGet;
  }
}

export class ResourcesService {
  public static async getLocations(id: number) {
    const url = `/Location?branchId=${id}`;

    try {
      const response: AxiosResponse = await axios.get(url);
      return response.data;
    } catch (error: any) {
      throw new MyError(error, error.response);
    }
  }

  public static async getResources(id: number) {
    const url = `/Resource?branchId=${id}`;

    try {
      const response: AxiosResponse = await axios.get(url);
      return response.data;
    } catch (error: any) {
      throw new MyError(error, error.response);
    }
  }

  public static async putResources(body: number) {
    const url = `/Resource`;

    try {
      const response: AxiosResponse = await axios.put(url, body);
      return response.data;
    } catch (error: any) {
      throw new MyError(error, error.response);
    }
  }
}
